import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

const styles = makeStyles<Theme>(theme => ({
  accordionRoot: {
    marginTop: theme.spacing(2),
    border: 0,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    '&:before': {
      backgroundColor: 'transparent',
    },
    '&$accordionExpanded': {
      paddingBottom: theme.spacing(1),
    },
  },
  accordionExpanded: {},
  accordionSummary: {
    padding: 0,
  },
  accordionDetails: {
    marginLeft: theme.spacing(5),
  },
}));

export default styles;
